<template>
    <!-- Modal Detail User -->
    <CModal
    title="Modal title"
    :show.sync="modalDetail"
    :no-close-on-backdrop="true"
    :centered="true"
    >
    <CRow>
        <div class="modal-body row my-n3">
        <div class="col-4">
            <p class="font-weight-bold">Nama Anggota</p>
            <p class="font-weight-bold">Kategori Anggota</p>
            <p class="font-weight-bold">No. Handphone</p>
            <p class="font-weight-bold">No. Telepon</p>
            <p class="font-weight-bold">Email</p>
        </div>
        <div class="col-8">
            <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
            <p>: {{ showKategori(formData) }}</p>
            <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
            <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
            <p>: {{ formData.email ? formData.email : ' - ' }}</p>
        </div>
        </div>
    </CRow>
    <template #header>
        <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
    </template>
    <template #footer>
        <router-link :to="`/keanggotaan/data-anggota/data-diri/${formData.id_user}`">
        <CButton color="info">Detail</CButton>
        </router-link>
        <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
    </template>
    </CModal>
    <!-- End Modal -->
</template>
<script>

export default {
    name: 'Modal',
    data() {
        return {
        }
    },
    components : {
    },
    props: [
        'modalDetail',
        'title',
        'formData'
    ],

    watch: {
        modalDetail: function(val) {
            if(!this.modalDetail) {                
                this.$emit('closeModalDetail', val)
            }            
        }
    },

    mounted() {
      
    },
    methods : {
        showKategori(formData) {
            if(formData.kategori_anggota) {
                return formData.kategori_anggota
            } else {
                if(formData.nama_kategori) {
                    return formData.nama_kategori;
                } else {
                    return "-"
                }
            }
        }
    },
    computed: {
      
    }
}
</script>